<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <table cellspacing="0" cellpadding="0" border="0">
      <tr>
        <td align="left" width="48" height="48">
          <img
            *mailgunIf="data.has_avatar; else initialsAvatar"
            class="avatar"
            width="48"
            height="48"
            alt=""
            [src]="data.avatar_url.toJSON()"
          />
          <ng-template #initialsAvatar>
            <div class="avatar avatar-initials">{{ data.initials.toJSON() }}</div>
          </ng-template>
        </td>
        <td width="12">&nbsp;</td>

        <td align="left" class="web-notification-title">
          <email-text [contents]="data.title" />
        </td>
      </tr>
    </table>
  </ng-container>

  <ng-container body>
    <email-margin [height]="28" />
    <email-text [contents]="data.body" presetName="paragraph" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer_p1" color="light" presetName="paragraph" size="small" />
    <email-link
      [label]="data.footer_link_text"
      [href]="data.footer_link"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
